<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  height: 19vh;
  color: #fff;
  text-align: center;
  overflow: hidden;

  .line {
    height: 19vh;
    margin-left: 3vh;

    .main {
      width: 100%;
      height: 24vh;
      margin-top: -3.5vh;
    }
  }
}
</style>

<template>
  <boxWrap :name="name" :min="true">
    <div class="table">
      <div class="line">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from '../common/boxWrap';
// import bar from 'components/dashboard/bar'
import echarts from "echarts";
export default {
  data() {
    return {
      name: '生产数据',
      dataY: [],
      dataX: []
    }
  },
  components: {
    boxWrap
    // bar
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData() {
      // for (var i = 0; i < 7; i++) {
      //   this.data[i] = this.data[i]
      //   // this.data[i] = Math.floor(Math.random() * 100);
      // }
      this.myChart = echarts.init(document.querySelector(".line .main"));
      this.myChart.clear()
      this.chart();
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".line .main"));
      this.myChart.setOption({
        animation: true,
        xAxis: {
          grid: {
            top: '20%',
            left: '30%',
            right: '10%',
            bottom: '20%',
            containLabel: true
          },
          data: this.dataX,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: "#fff",
            fontSize: 12,
            rotate: 30
          }
        },
        yAxis: {
          splitNumber: 4,
          name: '',
          min: 0,
          nameTextStyle: {
            color: "#fff",
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#fff",
            fontSize: 12,

            formatter: function (value, index) {
              if (value > 10000) {
                console.log(value)
                return value / 10000;
              } else {
                return value
              }
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0177d4"
            }
          }
        },
        series: [
          {
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 3,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#eb64fb'
                },
                {
                  offset: 1,
                  color: '#3fbbff0d'
                }
                ], false)
              }
            },
            itemStyle: {
              color: "red",
              borderColor: "#fff",
              borderWidth: 10
            },
            areaStyle: {
              normal: {
                color: '#3fbbff0d'
              }
            },
            data: this.dataY
          }
        ]
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  async mounted() {
    let { err, res } = await this.$model('dataManagement').commonfn2(this.$apiUrl.DATAANALYSIS.GetPlantingInfoStatistic);
    if (res.state === 200) {
      let resultData = res.results.dataList
      // console.log(resultData)
      for (var i = 0; i < resultData.length; i++) {
        this.dataY.push(resultData[i].harvestQuantity)
        this.dataX.push(resultData[i].month)
      }
    } else {
      this.$message.showError(err);
    }


    var self = this;
    self.chart();
    self.init();
    this.timer = setInterval(() => {
      // 某些定时器操作
      self.getData()
    }, 3000);
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?4b54acf0